/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Students_EyebrowInputs */

const en_about_students_eyebrow = /** @type {(inputs: About_Students_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notable Students`)
};

const es_about_students_eyebrow = /** @type {(inputs: About_Students_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alumnos destacados`)
};

const de_about_students_eyebrow = /** @type {(inputs: About_Students_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bemerkenswerte Studenten`)
};

const zh_about_students_eyebrow = /** @type {(inputs: About_Students_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`著名学生`)
};

const ar_about_students_eyebrow = /** @type {(inputs: About_Students_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`طلاب بارزون`)
};

const fr_about_students_eyebrow = /** @type {(inputs: About_Students_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Étudiants notables`)
};

const vi_about_students_eyebrow = /** @type {(inputs: About_Students_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Học viên nổi bật`)
};

const sw_about_students_eyebrow = /** @type {(inputs: About_Students_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wanafunzi mashuhuri`)
};

const th_about_students_eyebrow = /** @type {(inputs: About_Students_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`นักเรียนคนเก่ง`)
};

const bs_about_students_eyebrow = /** @type {(inputs: About_Students_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Istaknuti učenici`)
};

const ja_about_students_eyebrow = /** @type {(inputs: About_Students_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`著名な教え子`)
};

const ko_about_students_eyebrow = /** @type {(inputs: About_Students_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`주요 제자`)
};

const pt_about_students_eyebrow = /** @type {(inputs: About_Students_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alunos de destaque`)
};

const it_about_students_eyebrow = /** @type {(inputs: About_Students_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studenti notevoli`)
};

const sv_about_students_eyebrow = /** @type {(inputs: About_Students_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noterbara studenter`)
};

const nl_about_students_eyebrow = /** @type {(inputs: About_Students_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekende leerlingen`)
};

const da_about_students_eyebrow = /** @type {(inputs: About_Students_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bemærkelsesværdige studerende`)
};

const nb_about_students_eyebrow = /** @type {(inputs: About_Students_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kjente elever`)
};

const fi_about_students_eyebrow = /** @type {(inputs: About_Students_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merkittäviä oppilaita`)
};

const pl_about_students_eyebrow = /** @type {(inputs: About_Students_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studenci notowalni`)
};

const ru_about_students_eyebrow = /** @type {(inputs: About_Students_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Известные ученики`)
};

const tr_about_students_eyebrow = /** @type {(inputs: About_Students_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öne Çıkan Öğrenciler`)
};

const hi_about_students_eyebrow = /** @type {(inputs: About_Students_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उल्लेखनीय विद्यार्थी`)
};

const id_about_students_eyebrow = /** @type {(inputs: About_Students_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Murid ternama`)
};

const ms_about_students_eyebrow = /** @type {(inputs: About_Students_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelajar Terkenal`)
};

const cs_about_students_eyebrow = /** @type {(inputs: About_Students_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Významní studenti`)
};

const el_about_students_eyebrow = /** @type {(inputs: About_Students_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Αξιοσημείωτοι Μαθητές`)
};

const he_about_students_eyebrow = /** @type {(inputs: About_Students_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`תלמידים בולטים`)
};

const af_about_students_eyebrow = /** @type {(inputs: About_Students_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekende leerlinge`)
};

const hu_about_students_eyebrow = /** @type {(inputs: About_Students_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Híres hallgatók`)
};

/**
* | output |
* | --- |
* | "Notable Students" |
*
* @param {About_Students_EyebrowInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_students_eyebrow = /** @type {((inputs?: About_Students_EyebrowInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Students_EyebrowInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_students_eyebrow(inputs)
	if (locale === "de") return de_about_students_eyebrow(inputs)
	if (locale === "zh") return zh_about_students_eyebrow(inputs)
	if (locale === "ar") return ar_about_students_eyebrow(inputs)
	if (locale === "fr") return fr_about_students_eyebrow(inputs)
	if (locale === "vi") return vi_about_students_eyebrow(inputs)
	if (locale === "sw") return sw_about_students_eyebrow(inputs)
	if (locale === "th") return th_about_students_eyebrow(inputs)
	if (locale === "bs") return bs_about_students_eyebrow(inputs)
	if (locale === "ja") return ja_about_students_eyebrow(inputs)
	if (locale === "ko") return ko_about_students_eyebrow(inputs)
	if (locale === "pt") return pt_about_students_eyebrow(inputs)
	if (locale === "it") return it_about_students_eyebrow(inputs)
	if (locale === "sv") return sv_about_students_eyebrow(inputs)
	if (locale === "nl") return nl_about_students_eyebrow(inputs)
	if (locale === "da") return da_about_students_eyebrow(inputs)
	if (locale === "nb") return nb_about_students_eyebrow(inputs)
	if (locale === "fi") return fi_about_students_eyebrow(inputs)
	if (locale === "pl") return pl_about_students_eyebrow(inputs)
	if (locale === "ru") return ru_about_students_eyebrow(inputs)
	if (locale === "tr") return tr_about_students_eyebrow(inputs)
	if (locale === "hi") return hi_about_students_eyebrow(inputs)
	if (locale === "id") return id_about_students_eyebrow(inputs)
	if (locale === "ms") return ms_about_students_eyebrow(inputs)
	if (locale === "cs") return cs_about_students_eyebrow(inputs)
	if (locale === "el") return el_about_students_eyebrow(inputs)
	if (locale === "he") return he_about_students_eyebrow(inputs)
	if (locale === "af") return af_about_students_eyebrow(inputs)
	if (locale === "hu") return hu_about_students_eyebrow(inputs)
	return en_about_students_eyebrow(inputs)
});